import React, {useContext, useState} from "react";
import {QuotationContext} from "../../../contexts/QuotationContext";
import {MtplQuotation} from "../../../model/quotation";
import {
    findVehicleGroup,
    IVehicleAndPrimaryInsured,
    IVehicleIdentificationCodeRequest,
    IVehicleIdentificationCodeResponse,
    mapVehicleFields,
    Vehicle
} from "../../../model/vehicle";
import {MTPLPhoneNumberDialog} from "../../../components/dialogs/MTPLPhoneNumberDialog";
import {searchVehiclesByPhoneAndBirthdate, verifyVehiclesByPhoneAndBirthdate} from "../../../api/vehicleApiClient";
import {MTPLPhoneNumberConfirmDialog} from "../../../components/dialogs/MTPLPhoneNumberConfirmDialog";
import {NoDataByPhoneNumberDialog} from "../../../components/dialogs/NoDataByPhoneNumberDialog";
import {ChooseVehicleByPhoneNumberDialog} from "../../../components/dialogs/ChooseVehicleByPhoneNumberDialog";
import {mapPersonFields, Person} from "../../../model/party";
import {selectedViewEnam} from "../../../model/pageEnam";
import {strings} from "../../../strings/strings";

interface Props {
    setTextErrorMessageDialog: (string) => void
    setOpenErrorMessageDialog: (bool) => void
    description: () => React.ReactElement
}

export const PhoneAndDateBirthForms = ({setOpenErrorMessageDialog, setTextErrorMessageDialog, description}: Props) => {
    const {
        quotation,
        setSelectedView,
        setVehicleGroup,
        setVehicleFounded,
        setQuotation,
        isMtplPhoneNumberDialogOpen,
        setMtplPhoneNumberDialogOpen
    } = useContext<QuotationContext<MtplQuotation>>(QuotationContext);
    const [defaultVehicle] = useState<Vehicle>(quotation.mtplContract.vehicle);
    const quotationContext = useContext(QuotationContext);

    //find by phone dialogs
    const [vehicleIdentificationCodeRequest, setVehicleIdentificationCodeRequest] = useState<IVehicleIdentificationCodeRequest>({} as IVehicleIdentificationCodeRequest);
    const [vehicleIdentificationCodeResponse, setVehicleIdentificationCodeResponse] = useState<IVehicleIdentificationCodeResponse>({} as IVehicleIdentificationCodeResponse);
    const [isMtplPhoneNumberConfirmDialogOpen, setMtplPhoneNumberConfirmDialogOpen] = useState<boolean>(false);
    const [isNoDataByPhoneNumberDialogOpen, setNoDataByPhoneNumberDialogOpen] = useState<boolean>(false);
    const [isChooseVehicleByPhoneNumberDialogOpen, setChooseVehicleByPhoneNumberDialogOpen] = useState<boolean>(false);

    const resetVehicleFields = () => {
        const newQuotation = {...quotation};
        newQuotation.mtplContract.vehicle = {...defaultVehicle};
        setQuotation(newQuotation);
    };

    const onSearchByPhoneListener = (vehicle: Vehicle, person: Person) => {
        mapPersonFields(person, quotation.mtplContract.primaryInsured)
        onSearchListener(vehicle);
        setVehicleIdentificationCodeRequest({} as IVehicleIdentificationCodeRequest);
        setVehicleIdentificationCodeResponse({} as IVehicleIdentificationCodeResponse);
    }

    const onSearchListener = (vehicle: Vehicle) => {
        resetVehicleFields();
        const updatedVehicle = mapVehicleFields(vehicle, quotation.mtplContract.vehicle);

        if (vehicle.vehicleType) {
            setVehicleGroup(findVehicleGroup(vehicle.vehicleType));
        }

        setQuotation({
            ...quotation, 
            mtplContract: {
                ...quotation.mtplContract,
                vehicle: updatedVehicle
            }
        })
        setVehicleFounded(true);
    }

    const renderSearchByPhoneNumberDialogs = () => {
        return <>
            <MTPLPhoneNumberDialog
                isOpen={isMtplPhoneNumberDialogOpen}
                onSubmit={async (values) => {
                    const request = {
                        ...vehicleIdentificationCodeRequest,
                        phoneNumber: values.phone,
                        birthDate: values.birthDate,
                        saleVariantCode: quotation.salesVariant
                    };

                    setVehicleIdentificationCodeRequest(request);

                    try {
                        const response: IVehicleIdentificationCodeResponse = await searchVehiclesByPhoneAndBirthdate(request);

                        if (!response?.controlCode) {
                            setOpenErrorMessageDialog(true);
                            setTextErrorMessageDialog(strings.mtplPhoneNumberConfirmDlg.text4);
                        } else {
                            setVehicleIdentificationCodeResponse(response);
                            setVehicleIdentificationCodeRequest({
                                ...request,
                                identificationCode: response.identificationCodeId
                            });
                            setMtplPhoneNumberDialogOpen(false);
                            setMtplPhoneNumberConfirmDialogOpen(true);
                        }
                    } catch (e) {
                        setMtplPhoneNumberDialogOpen(false);
                        setNoDataByPhoneNumberDialogOpen(true);
                    }
                }}
            />

            <MTPLPhoneNumberConfirmDialog isOpen={isMtplPhoneNumberConfirmDialogOpen}
                                          onSubmit={async (code) => {
                                              const request = {
                                                  ...vehicleIdentificationCodeRequest,
                                                  verificationCode: code,
                                                  saleVariantCode: quotation.salesVariant
                                              };

                                              setVehicleIdentificationCodeRequest(request);

                                              const response: IVehicleIdentificationCodeResponse = await verifyVehiclesByPhoneAndBirthdate(request);
                                              setVehicleIdentificationCodeResponse(response);

                                              if (response.vehicleAndPrimaryInsuredList.length) {
                                                  if (response.vehicleAndPrimaryInsuredList.length > 1) {
                                                      setVehicleIdentificationCodeResponse(response);
                                                      setChooseVehicleByPhoneNumberDialogOpen(true);
                                                      setMtplPhoneNumberConfirmDialogOpen(false)
                                                  } else {
                                                      onSearchByPhoneListener(response.vehicleAndPrimaryInsuredList[0].vehicle,
                                                          response.vehicleAndPrimaryInsuredList[0].primaryInsured
                                                      );
                                                      setSelectedView(selectedViewEnam.NEWCLIENT);
                                                      setMtplPhoneNumberConfirmDialogOpen(false);
                                                  }
                                                  let getEvent = () => {
                                                      switch (quotation.salesVariant) {
                                                          case 'svs_05910264_package':
                                                              return '_SD_go_by_phone';
                                                          case 'svs_05910203_simple':
                                                              return 'mtpl_go_by_phone';
                                                          case 'svs_09710001_simple':
                                                              return 'green_card_go_phone';
                                                      }
                                                  }
                                                  console.log('Google Analytics Event = ' + getEvent());
                                                  // @ts-ignore
                                                  window.dataLayer.push({'event': getEvent()});
                                              } else {

                                                  if (quotation.salesVariant == 'svs_09710001_simple') {
                                                      let event = 'green_card_error_phone';
                                                      console.log('Google Analytics Event = ' + event);
                                                      // @ts-ignore
                                                      window.dataLayer.push({'event': event});
                                                  }

                                                  setMtplPhoneNumberConfirmDialogOpen(false);
                                                  setNoDataByPhoneNumberDialogOpen(true);
                                              }
                                          }}
                                          onCancel={async () => {
                                              const response: IVehicleIdentificationCodeResponse = await searchVehiclesByPhoneAndBirthdate(vehicleIdentificationCodeRequest)

                                              setVehicleIdentificationCodeResponse(response);
                                              setVehicleIdentificationCodeRequest({
                                                  ...vehicleIdentificationCodeRequest,
                                                  identificationCode: response.identificationCodeId
                                              });
                                          }}
                                          phoneNumber={vehicleIdentificationCodeRequest.phoneNumber}
                                          controlCode={vehicleIdentificationCodeResponse.controlCode}
            />

            <NoDataByPhoneNumberDialog isOpen={isNoDataByPhoneNumberDialogOpen}
                                       onManual={() => {
                                           setNoDataByPhoneNumberDialogOpen(false);
                                           setVehicleIdentificationCodeRequest({} as IVehicleIdentificationCodeRequest);
                                           setVehicleIdentificationCodeResponse({} as IVehicleIdentificationCodeResponse);
                                           setSelectedView(selectedViewEnam.MANUAL);
                                           const getEvent = () => {
                                               switch (quotation.salesVariant) {
                                                   case 'svs_05910264_package':
                                                       return '_SD_go_manual';
                                                   case 'svs_05910203_simple':
                                                       return 'mtpl_go_manual';
                                                   case 'svs_09710001_simple':
                                                       return 'green_card_error_phone';
                                               }
                                           }
                                           console.log('Google Analytics Event = ' + getEvent());
                                           // @ts-ignore
                                           window.dataLayer.push({'event': getEvent()});
                                       }}
                                       onSearch={() => {
                                           setNoDataByPhoneNumberDialogOpen(false);
                                           setVehicleIdentificationCodeRequest({} as IVehicleIdentificationCodeRequest);
                                           setVehicleIdentificationCodeResponse({} as IVehicleIdentificationCodeResponse);
                                           setSelectedView(selectedViewEnam.SECONDSEARCH)
                                       }}
                                       phoneNumber={vehicleIdentificationCodeRequest.phoneNumber}
            />

            <ChooseVehicleByPhoneNumberDialog isOpen={isChooseVehicleByPhoneNumberDialogOpen}
                                              foundVehicles={vehicleIdentificationCodeResponse.vehicleAndPrimaryInsuredList}
                                              onCancel={() => {
                                                  setChooseVehicleByPhoneNumberDialogOpen(false);
                                                  setVehicleIdentificationCodeRequest({} as IVehicleIdentificationCodeRequest);
                                                  setVehicleIdentificationCodeResponse({} as IVehicleIdentificationCodeResponse);
                                                  setSelectedView(selectedViewEnam.MANUAL);

                                                  const event = quotationContext.quotation.salesVariant === 'svs_05910264_package' ? '_SD_go_manual' : 'mtpl_go_manual'
                                                  console.log('Google Analytics Event = ' + event);
                                                  // @ts-ignore
                                                  window.dataLayer.push({'event': event});
                                              }}
                                              onSubmit={(selected: IVehicleAndPrimaryInsured) => {
                                                  onSearchByPhoneListener(selected.vehicle, selected.primaryInsured)
                                                  setChooseVehicleByPhoneNumberDialogOpen(false);
                                                  setSelectedView(selectedViewEnam.NEWCLIENT);
                                              }}
            />
        </>
    }

    return (
        <div className="step-view vehicle-search-view">
            <div className={"vehicle-search-view__search"}>
                {setMtplPhoneNumberDialogOpen(true)}
                {renderSearchByPhoneNumberDialogs()}
            </div>
            <div className={"vehicle-search-view__description"}>
                {description()}
            </div>
        </div>
    )
}
